<template>
  <SoAlert
    v-if="query.isError"
    title="Failed to load test accounts"
    data-testid="test-accounts-error"
  />

  <div v-else>
    <SoDataTable
      :headers="headers"
      :items="query.data"
      :loading="query.isFetching"
      searchable
      search-placeholder="Search by account number, fuel type, or status"
      data-testid="test-accounts-table"
    />
  </div>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoDataTable from "@/components/dataTable/SoDataTable.vue"
  import SoAlert from "@/components/SoAlert.vue"
  import { TestAccountsService } from "@/services/admin/TestAccountsService"

  export default defineComponent({
    components: {
      SoDataTable,
      SoAlert,
    },
    data() {
      return {
        query: TestAccountsService.getTestAccounts(),
        headers: [
          {
            title: "Account Number",
            key: "accountNum",
            sortable: true,
          },
          {
            title: "Billing Account ID",
            key: "billingAccId",
            sortable: true,
          },
          {
            title: "Fuel Type",
            key: "fuelType",
            sortable: true,
          },
          {
            title: "Status",
            key: "latestStatus",
            sortable: true,
          },
          {
            title: "Renewal Window",
            key: "insideRenewalWindow",
            sortable: true,
          },
          {
            title: "Active Agreement",
            key: "isActiveAgreement",
            sortable: true,
          },
          {
            title: "Multi Meterpoints",
            key: "multiMeterpoints",
            sortable: true,
          },
          {
            title: "Seasonal",
            key: "isSeasonal",
            sortable: true,
          },
          {
            title: "To Date",
            key: "toDate",
            sortable: true,
          },
        ],
      }
    },
  })
</script>
